<template>
  <div class="wrap p-t-lg">
    <div class="container">
      <div class="p-t-md">
        <div class="row">
          <div class="main-content" v-if="evaluate_result.abilities && evaluate_result.abilities.length > 0">
            <h2 class="m-b-sm">
              <span v-if="evaluate.category === 2">岗位</span>测评报告详情
              <span class="btn btn-primary right" @click="download()">下载报告</span>
            </h2>
            <div class="b-b"></div>
            <div id="report-area" class="row">
              <div class="col-xs-12">
                <div class="row user-info p-b-sm" v-if="evaluate.category === 2">
                  <div class="col-xs-12">
                    <div class="row">
                      <div class="col-xs-6">
                        <div class="line">
                          <span class="label">姓名:</span>
                          <span class="info">{{tester.realname?tester.realname:tester.nickname}}</span>
                        </div>
                        <div class="line">
                          <span class="label">邮箱:</span>
                          <span class="info">{{tester.email}}</span>
                        </div>
                        <div class="line" v-if="tester.phone">
                          <span class="label">手机:</span>
                          <span class="info">{{tester.phone}}</span>
                        </div>
                        <div class="line">
                          <span class="label">岗位:</span>
                          <span class="info">{{evaluate.name}}</span>
                        </div>
                      </div>
                      <div class="col-xs-6">
                        <img :src="tester.avatar" alt="" width="100" class="m-r-sm right" v-if="tester.avatar">
                      </div>
                    </div>
                    <div class="b-b m-tb-sm "></div>
                  </div>
                </div>
                <div class="col-xs-12">
                  <table class="table table-border" border="1">
                    <thead>
                      <tr>
                        <th style="text-align:center;" rowpan="2">能力群</th>
                        <th style="text-align:center;" rowpan="2">得分</th>
                        <th style="text-align:center;" colspan="2">得分排名</th>
                        <th style="text-align:center;" colspan="4">详情</th>
                      </tr>
                      <tr>
                        <th style="text-align:center;">求职者</th>
                        <th style="text-align:center;">在职人员</th>
                        <th style="text-align:center;">指标</th>
                        <th style="text-align:center;">得分</th>
                        <th style="text-align:center;">求职者</th>
                        <th style="text-align:center;">在职人员</th>
                      </tr>
                    </thead>
                    <tbody v-for="ability in evaluate_result.abilities" :key="ability._id">
                      <tr>
                        <td style="text-align:center;" :rowpan="ability.indicators.length">{{ability.ability.name}}</td>
                        <td style="text-align:center;" :rowpan="ability.indicators.length">{{ability.score.toFixed(2)}}</td>
                        <td style="text-align:center;" :rowpan="ability.indicators.length">超过
                          <span class="num">{{(ability.rate*100).toFixed(2)}}%</span>
                        </td>
                        <td style="text-align:center;" :rowpan="ability.indicators.length">超过
                          <span class="num">{{(ability.entry_rate*100).toFixed(2)}}%</span>
                        </td>
                        <td>{{ability.indicators[0].indicator.name}}</td>
                        <td>{{ability.indicators[0].score.toFixed(2)}}</td>
                        <td>超过
                          <span class="num">{{(ability.indicators[0].rate*100).toFixed(2)}}%</span>
                        </td>
                        <td>超过
                          <span class="num">{{(ability.indicators[0].entry_rate*100).toFixed(2)}}%</span>
                        </td>
                      </tr>
                      <tr v-for="ind in (ability.indicators.slice(1))" :key="ind._id">
                        <td>{{ind.indicator.name}}</td>
                        <td>{{ind.score.toFixed(2)}}</td>
                        <td>超过
                          <span class="num">{{(ind.rate*100).toFixed(2)}}%</span>
                        </td>
                        <td>超过
                          <span class="num">{{(ind.entry_rate*100).toFixed(2)}}%</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-xs-12">
                  <h5 class="text-center">本报告由
                    <a href="http://www.psych.cas.cn" title="中国科学院心理研究所" alt="中国科学院心理研究所" style="color:#000">中国科学院心理研究所</a> 提供测评技术支持</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row p-t-b-md text-center">
          <router-link to="/evaluate" class="btn btn-md btn-primary">参与更多测评，完善个人档案 &gt;&gt;</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Evaluate from "../../resource/evaluate";

import H2C from "html2canvas";
import jQuery from "jquery";

export default {
  name: "EvaluateReport",
  data: function() {
    return {
      evaluate: {},
      company: {},
      tester: {},
      code: "",
      is_mounted: false,
      radar: null,
      bar: null,
      evaluate_result: {
        abilities: []
      }
    };
  },
  components: {},
  watch: {
    // 监控数据
    evaluate: function(now, pre) {
      if (now.name !== pre.name) {
        document.title = `测评报告：${now.name}`;
      }
    },
    "evaluate_result.abilities": function(now) {
      let that = this;
    }
  },
  created: function() {
    // 页面渲染完成后
    let that = this;
    Evaluate.questionnaire({ code: that.$route.params.code }).then(
      res => {
        let data = res.body;
        if (data.code === 0 || data.code === 4) {
          that.evaluate = data.result.questionnaire;
          that.company = data.result.company;
          that.tester = data.result.tester || {};
          that.type = data.result.category === "questionnaire" ? 1 : 2; // 问卷还是code
          if (data.result.code) {
            // 设置code
            that.code = data.result.code;
          }
          if (data.code === 4) {
            that.code = that.$route.params.code;
            that.loadReport();
            return;
          }
          if (data.result.is_login === 1) {
            if (that.type === 1) {
              // 问卷
              if (data.result.status > 1) {
                // 结束测评
                that.loadReport();
                return;
              } else {
                that.$router.replace({
                  name: "EvaluateShow",
                  params: { code: that.code }
                });
              }
            } else {
              // 测评
              if (that.code === that.$route.params.code) {
                // 同一个测评
                if (data.result.status > 1) {
                  // 结束测评
                  that.loadReport();
                } else {
                  that.$router.replace({
                    name: "EvaluateShow",
                    params: { code: that.code }
                  });
                }
              } else {
                //  非同一个测评
                if (data.result.status > 1) {
                  // 结束测评
                  if (res.code === 0) {
                    // 正常用户
                    that
                      .$http({
                        method: "PUT",
                        url: `/evaluate/copy_evaluate`,
                        body: {
                          used_code: that.code,
                          unused_code: that.$route.params.code
                        }
                      })
                      .then(
                        res => {
                          let data = res.body;
                          if (data.code === 0) {
                            // 载入
                            that.code = that.$route.params.code;
                            that.loadReport();
                          } else {
                            // 异常跳转
                            alert(data.msg);
                            that.$router.replace({
                              name: "EvaluateShow",
                              params: { code: that.$route.params.code }
                            });
                          }
                        },
                        res => {
                          // 异常跳转
                          that.$router.replace({
                            name: "EvaluateShow",
                            params: { code: that.$route.params.code }
                          });
                        }
                      );
                  }
                } else {
                  // 未结束测评
                  that.$router.replace({
                    name: "EvaluateShow",
                    params: { code: that.$route.params.code }
                  });
                }
              }
            }
          } else {
            // 未登录无权限
            that.$router.replace({
              name: "EvaluateShow",
              params: { code: that.$route.params.code }
            });
          }
        } else {
          // 无权限
          that.$router.replace({ name: "EvaluateList" });
        }
        that.is_processing = 0;
      },
      res => {
        that.is_processing = 0;
      }
    );
  },
  mounted: function() {
    let that = this;
    that.is_mounted = true;
  },
  methods: {
    loadReport: function() {
      let that = this;
      that.$http.get(`/api/v1/evaluate/${that.code}/report`).then(
        res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              let report = data.result;
              let indicators = {};
              report.indicators.forEach(indicator => {
                indicator.rate_text = (indicator.rate * 100).toFixed(2) + "%";
                indicator.dasharray =
                  indicator.rate * 314 + " " + (1 - indicator.rate) * 314;
                indicators[indicator.indicator._id] = indicator;
              });
              report.abilities.forEach(ability => {
                let tmpIndicators = [];
                ability.indicators.forEach((indicator, index, arr) => {
                  var tmp = indicators[indicator.indicator];
                  if (tmp) {
                    for (let p in tmp) {
                      indicator[p] = tmp[p];
                    }
                    tmpIndicators.push(indicator);
                  }
                });
                ability.indicators = tmpIndicators;
                ability.is_open = 1;
              });
              that.evaluate_result = report;
            } else {
              alert(data.msg);
            }
          } else {
            alert(res.status);
          }
        },
        res => {}
      );
    },
    download: function() {
      const that = this;
      const doc = window.document;
      const ra = doc.querySelector("#report-area");
      H2C(ra, {
        background: "#fff",
        // allowTaint: true,
        useCORS: true,
        onrendered: function(canvas) {
          var $form = jQuery(
            '<form method="post" action="/api/base642pdf"></form>'
          );
          $form.append(
            '<input type="hidden" name="base64" value="' +
              canvas.toDataURL() +
              '" />'
          );
          $form.append(
            `<input type="hidden" name="name" value="${that.tester.realname}-${
              that.evaluate.name
            }" />`
          );
          $form.append(
            `<input type="hidden" name="height" value="${canvas.height}" />`
          );
          $form.append(
            `<input type="hidden" name="width" value="${canvas.width}" />`
          );
          $form.append(`<input type="hidden" name="category" value="2" />`);
          jQuery(document.body).append($form);
          $form[0].submit();
          $form.remove();
        }
      });
    }
  },
  destroyed: function() {
    let that = this;
    if (that.radar) {
      that.radar.dispose();
      that.radar = null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#radar-area {
  height: 300px;
}

.num {
  color: darkorange;
}
</style>



// WEBPACK FOOTER //
// detail.vue?627665b7